const isElement = (candidate?: Node): candidate is Element =>
  !!candidate && candidate.nodeType === Node.ELEMENT_NODE;

export default isElement;
